export default __webpack_public_path__ + "static/media/woman.b8567abc.png";